var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{staticClass:"pa-0 ma-0",attrs:{"flat":""},on:{"click":function($event){return _vm.openInteractionsDialog()}}},[_c('v-row',{staticClass:"pa-0 ma-0 vetalfa-row",attrs:{"align":"center","justify":"center"}},[_c('v-icon',{attrs:{"size":"26","color":"primary"}},[_vm._v(_vm._s(_vm._icon("drugsInteractions")))])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }